import Vue, { PropType } from "vue";
import { QuestViewModel } from "@/interfaces/QuestViewModel";
import { AffiliateProductRx } from "@/interfaces/AffiliateProductRx";
import { PaymentViewModel } from "@/interfaces/PaymentViewModel";

export default Vue.extend({
  props: {
    q: Object as PropType<QuestViewModel> | PropType<PaymentViewModel>,
  },
  data() {
    return {
      prxs: [] as AffiliateProductRx[],
      prxChoices: [] as AffiliateProductRx[][],
    };
  },
  methods: {
    setPrxChoices(prsc: AffiliateProductRx[], selectedProductRx?: AffiliateProductRx) {
      prsc.forEach((p) => {
        this.prxChoices[p.productRxGroupID] = this.getDaysSupply(p);
        if (selectedProductRx && selectedProductRx.productRxGroupID == p.productRxGroupID) {
          this.prxs[p.productRxGroupID] = selectedProductRx;
          this.prxChoices[p.productRxGroupID] = this.prxChoices[p.productRxGroupID].filter((x) => x.daysSupply != selectedProductRx.daysSupply);
          this.prxChoices[p.productRxGroupID].push(selectedProductRx);
        } else {
          this.prxs[p.productRxGroupID] = p;
        }
      });
    },
    getDaysSupply(p: AffiliateProductRx) {
      return this.q.products.filter((y) => !y.isSubstitution && y.productRxGroupID == p.productRxGroupID && y.unitsPerDose == p.unitsPerDose).sort((a, b) => a.daysSupply - b.daysSupply);
    },
  },
});
